import { withTranslation } from '@application/i18n/with_translation';
import { Button, Divider, Flex, Form, useFormContext } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useDynamicFormContext } from './dynamic_form.context';
import { useFormWorkerState } from './form_manager/use_form_worker';

export function DynamicFormActions(): JSX.Element | null {
	const context = useDynamicFormContext();
	const formContext = useFormContext();
	const { meta, pagePosition, completed, editable } = useFormWorkerState(context.formWorker);

	if (meta == null) {
		return null;
	}

	function handleGoBack(): void {
		context.formWorker.changePage('backwards', formContext?.control.getValues() ?? {});
	}

	const getSubmitButtonLabel = (): string => {
		if (pagePosition !== meta.pages.length - 1) {
			return withTranslation('Feature.DynamicForms.Button.Forward');
		}
		if (!completed || editable) {
			return withTranslation('Feature.DynamicForms.Button.Send');
		}
		return withTranslation('Feature.DynamicForms.Button.Close');
	};

	return (
		<>
			<Flex grow={1} />

			<Divider />
			<Flex justify='space-between' gap={tokens.spacing.x1} direction='row'>
				{pagePosition > 0 && meta.pages.length !== 1 ? (
					<Button
						type='button'
						size='medium'
						disabled={pagePosition === 0}
						disabledText={withTranslation('Feature.DynamicForms.Button.Backwards.AriaDisabled')}
						variant='secondary'
						onClick={handleGoBack}
					>
						{withTranslation('Feature.DynamicForms.Button.Backwards')}
					</Button>
				) : null}
				<Flex grow={1} />
				<Form.SubmitButton size='medium' variant='primary'>
					{getSubmitButtonLabel()}
				</Form.SubmitButton>
			</Flex>
		</>
	);
}
